import {
  BurialAddPage,
  BurialDetailPage,
  BurialListPage,
  MemberListPage,
  MemberDetailPage,
  RecommendListPage,
  ParkConsultingListPage,
  ParkConsultingDetailPage,
  AskGraveMoveListPage,
  AskGraveMoveDetailPage,
  NoticeListPage,
  NoticeDetailPage,
  OnelineNoticeListPage,
  ReviewListPage,
  ReviewDetailPage,
  FaqListPage,
  FaqDetailPage,
  InquiryListPage,
  InquiryDetailPage,
  CooperateListPage,
  CooperateDetailPage,
  BlogListPage,
  BlogDetailPage,
  FoldingScreenListPage,
  FoldingScreenDetailPage,
  TableSettingListPage,
  TableSettingDetailPage,
  GraveListPage,
  GraveDetailPage,
  FuneralListPage,
  FuneralDetailPage,
  InheritanceListPage,
  InheritanceDetailPage,
  MemoryListPage,
  MemoryDetailPage,
  CasesListPage,
  CasesDetailPage,
  AlimtalkPage,
} from "pages";
import routerConstant from "service/constant/routerConstant";

export const privateRoute = [
  {
    path: routerConstant.BURIAL.add,
    Component: <BurialAddPage />,
  },
  {
    path: `${routerConstant.BURIAL.index}/:id`,
    Component: <BurialDetailPage />,
  },
  {
    path: routerConstant.BURIAL.list,
    Component: <BurialListPage />,
  },
  {
    path: routerConstant.MEMBER.list,
    Component: <MemberListPage />,
  },
  {
    path: `${routerConstant.MEMBER.index}/:id`,
    Component: <MemberDetailPage />,
  },
  {
    path: routerConstant.RECOMMEND.list,
    Component: <RecommendListPage />,
  },
  {
    path: routerConstant.PARKCONSULTING.list,
    Component: <ParkConsultingListPage />,
  },
  {
    path: `${routerConstant.PARKCONSULTING.index}/:id`,
    Component: <ParkConsultingDetailPage />,
  },
  {
    path: routerConstant.ASKGRAVEMOVE.list,
    Component: <AskGraveMoveListPage />,
  },
  {
    path: `${routerConstant.ASKGRAVEMOVE.index}/:id`,
    Component: <AskGraveMoveDetailPage />,
  },
  {
    path: routerConstant.GRAVE.list,
    Component: <GraveListPage />,
  },
  {
    path: `${routerConstant.GRAVE.index}/:id`,
    Component: <GraveDetailPage />,
  },
  {
    path: routerConstant.FUNERAL.list,
    Component: <FuneralListPage />,
  },
  {
    path: `${routerConstant.FUNERAL.index}/:id`,
    Component: <FuneralDetailPage />,
  },
  {
    path: routerConstant.INHERITANCE.list,
    Component: <InheritanceListPage />,
  },
  {
    path: `${routerConstant.INHERITANCE.index}/:id`,
    Component: <InheritanceDetailPage />,
  },
  {
    path: routerConstant.MEMORY.list,
    Component: <MemoryListPage />,
  },
  {
    path: `${routerConstant.MEMORY.index}/:id`,
    Component: <MemoryDetailPage />,
  },
  {
    path: routerConstant.NOTICE.list,
    Component: <NoticeListPage />,
  },
  {
    path: `${routerConstant.NOTICE.index}/:id`,
    Component: <NoticeDetailPage />,
  },
  {
    path: routerConstant.ONELINENOTICE.list,
    Component: <OnelineNoticeListPage />,
  },
  {
    path: routerConstant.REVIEW.list,
    Component: <ReviewListPage />,
  },
  {
    path: `${routerConstant.REVIEW.index}/:id`,
    Component: <ReviewDetailPage />,
  },
  {
    path: routerConstant.FAQ.list,
    Component: <FaqListPage />,
  },
  {
    path: `${routerConstant.FAQ.index}/:id`,
    Component: <FaqDetailPage />,
  },
  {
    path: routerConstant.INQUIRY.list,
    Component: <InquiryListPage />,
  },
  {
    path: `${routerConstant.INQUIRY.index}/:id`,
    Component: <InquiryDetailPage />,
  },
  {
    path: routerConstant.COOPERATE.list,
    Component: <CooperateListPage />,
  },
  {
    path: `${routerConstant.COOPERATE.index}/:id`,
    Component: <CooperateDetailPage />,
  },
  {
    path: routerConstant.BLOG.list,
    Component: <BlogListPage />,
  },
  {
    path: `${routerConstant.BLOG.index}/:id`,
    Component: <BlogDetailPage />,
  },
  {
    path: routerConstant.FOLDINGSCREEN.list,
    Component: <FoldingScreenListPage />,
  },
  {
    path: `${routerConstant.FOLDINGSCREEN.index}/:id`,
    Component: <FoldingScreenDetailPage />,
  },
  {
    path: routerConstant.TABLESETTING.list,
    Component: <TableSettingListPage />,
  },
  {
    path: `${routerConstant.TABLESETTING.index}/:id`,
    Component: <TableSettingDetailPage />,
  },
  {
    path: routerConstant.CASES.list,
    Component: <CasesListPage />,
  },
  {
    path: `${routerConstant.CASES.index}/:id`,
    Component: <CasesDetailPage />,
  },
  {
    path: routerConstant.ALIMTALK.index,
    Component: <AlimtalkPage />,
  },
];
